"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M771.548 960.11L319 1412.658l188.562 188.562 452.548-452.548 452.548 452.548 188.562-188.562-452.548-452.548 452.548-452.548L1412.658 319 960.11 771.548 507.562 319 319 507.562z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconX =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconX, _Component);

  function IconX() {
    (0, _classCallCheck2.default)(this, IconX);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconX).apply(this, arguments));
  }

  (0, _createClass2.default)(IconX, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconX",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconX.displayName = "IconX";
  return IconX;
}(_react.Component);

exports.default = IconX;
IconX.glyphName = 'x';
IconX.variant = 'Solid';
IconX.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);